// import React from 'react'
// import loginsignupImage from "../asset/login-animation.gif"
// import {Link, useNavigate} from "react-router"
// import { useState } from 'react'
// import { ImagetoBase64 } from '../utility/Imagetobase64'
// import {toast} from "react-hot-toast";

// function Signup() {
//     const navigate= useNavigate()


//     const [data, setData]= useState({
//         firstName: "",
//         lastName: "",
//         email: "",
//         password: "",
//         confirmpassword: "",
//         image: "",
//     });

//     const handleOnChange= (e)=> {
//         const {name, value}= e.target
//         setData((preve)=>{
//             return {
//                 ...preve,
//                 [name]: value
//             }
//         })
//     }

//     const handleUploadProfileImage= async(e) => {
//         const data= await ImagetoBase64(e.target.files[0])

//         setData((preve)=>{
//             return{
//                 ...preve,
//                 image: data
//             }
//         })
//     }

//     const handleSubmit= async (e)=>{
//         e.preventDefault()
//         const {firstName, email, password, confirmpassword}= data

//         if(firstName && email && password && confirmpassword){
//             if(password === confirmpassword){
//                 // Server url is required
//                 const fetchData= await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/signup`,{
//                     method: "POST",
//                     headers:{
//                         "content-type": "application/json"
//                     },
//                     body: JSON.stringify(data)
//                 })

//                 const dataRes = await fetchData.json()
//                 // console.log(dataRes)
//                 // console.log("Success")

//                 // alert(dataRes.message)
//                 toast(dataRes.message)
//                 if(dataRes.alert){
//                     navigate("/login")
//                 }
                
//             }
//             else{
//                 alert("password and cofirmpassword not equal")
//             }
//         }
//         else{
//             alert("Please enter required field")
//         }
//     }

//   return (
//     <div className='p-3 md:p-4'>
//         <div className='w-full max-w-sm bg-white m-auto flex flex-col p-4'>
//             {/* <h1 className='text-center text-2xl font-bold'>Sign up</h1> */}
//             <div className='w-20 h-20 overflow-hidden rounded-full drop-shadow-md shadow-md m-auto relative '>
//                 <img src= {data.image? data.image: loginsignupImage} alt= "ProfilePic" className='w-full'/>


//             <label htmlFor='profileImage' >
//                 <div className="absolute bottom-0 h-1/3 bg-slate-500 bg-opacity-20 w-full text-center cursor-pointer">
//                     <p className='text-sm p-1 text-white'>Upload</p>
//                 </div>
//                 <input type= {"file"} id= "profileImage" accept= "image/*" className= "hidden" onChange={handleUploadProfileImage}/>
//             </label>
//             </div>

//             <form className='w-full py-3 flex flex-col'onSubmit= {handleSubmit}>
//             <label htmlFor= 'firstName'>First Name</label>
//                 <input type= {"text"} id="firstName" name='firstName' className= 'mt-1 mb-2 w-full bg-slate-200 px-2 py-1 rounded focus-within:outline-blue-300' 
//                 value= {data.firstName}
//                 onChange= {handleOnChange}
//                 />

//                 <label htmlFor= 'lastName'>Last Name</label>
//                 <input type= {"text"} id="lastName" name='lastName' className= 'mt-1 mb-2 w-full bg-slate-200 px-2 py-1 rounded focus-within:outline-blue-300' 
//                 value= {data.lastName}
//                 onChange= {handleOnChange}
//                 />

//                 <label htmlFor= 'email'>Email</label>
//                 <input type= {"email"} id="email" name='email' className= 'mt-1 mb-2 w-full bg-slate-200 px-2 py-1 rounded focus-within:outline-blue-300' 
//                 value= {data.email}
//                 onChange= {handleOnChange}
//                 />
                
//                 <label htmlFor= 'password'>Password</label>
//                 <input type= {"password"} id="password" name= 'password' className= 'mt-1 mb-2 w-full bg-slate-200  px-2 py-1 rounded focus-within:outline-blue-300'
//                 value= {data.password}
//                 onChange= {handleOnChange}
//                 />
            
//                 <label htmlFor= 'confirmpassword'>Confirm Password</label>
//                 <input type= {"password"} id= "confirmpassword"  name= 'confirmpassword' className= 'mt-1 mb-2 w-full bg-slate-200 px-2 py-1 rounded focus-within:outline-blue-300'
//                 value= {data.confirmpassword}
//                 onChange= {handleOnChange}
//                 />
            
//                 <button className= " w-full max-w-[150px] m-auto bg-red-500 hover:bg-red-600 cursor-pointer text-white text-xl font-medium text-center py-1 rounded-full mt-4">
//                     Sign up
//                 </button>
//               </form>

//               <p className='text-left text-sm mt-2'>Already have account ? <Link to={"/login"} className='text-red-500 underline'>Login</Link></p>
//         </div>
//     </div>
//   )
// }

// export default Signup



import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { toast } from 'react-hot-toast';
import { ImagetoBase64 } from '../utility/Imagetobase64';

import { BsLightningChargeFill, BsPersonCircle } from 'react-icons/bs';
import { HiOutlineMail, HiOutlineLockClosed, HiOutlineUser } from 'react-icons/hi';
import { MdAddAPhoto } from 'react-icons/md';

export default function Signup() {
  const navigate  = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    firstName: '', lastName: '', email: '',
    password: '', confirmpassword: '', image: '',
  });

  const handle = (e) =>
    setData(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleImage = async (e) => {
    const b64 = await ImagetoBase64(e.target.files[0]);
    setData(p => ({ ...p, image: b64 }));
  };

  const submit = async (e) => {
    e.preventDefault();
    const { firstName, email, password, confirmpassword } = data;
    if (!firstName || !email || !password || !confirmpassword) {
      toast.error('Please fill all required fields'); return;
    }
    if (password !== confirmpassword) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      const res  = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/signup`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(data),
      });
      const json = await res.json();
      toast(json.alert ? 'success' : 'error', json.message);
      if (json.alert) navigate('/login');
    } catch { toast.error('Something went wrong'); }
    finally   { setLoading(false); }
  };

  const fields = [
    { name: 'firstName', label: 'First Name',        type: 'text',     Icon: HiOutlineUser,     placeholder: 'John' },
    { name: 'lastName',  label: 'Last Name',         type: 'text',     Icon: HiOutlineUser,     placeholder: 'Doe' },
    { name: 'email',     label: 'Email',             type: 'email',    Icon: HiOutlineMail,     placeholder: 'you@example.com' },
    { name: 'password',  label: 'Password',          type: 'password', Icon: HiOutlineLockClosed, placeholder: '••••••••' },
    { name: 'confirmpassword', label: 'Confirm Password', type: 'password', Icon: HiOutlineLockClosed, placeholder: '••••••••' },
  ];

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-12 relative overflow-hidden"
      style={{ background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 100%)' }}
    >
      {/* Blobs */}
      <div className="pointer-events-none absolute"
           style={{ top: '10%', right: '15%', width: 500, height: 500,
             background: 'radial-gradient(circle, rgba(99,102,241,0.09) 0%, transparent 70%)',
             filter: 'blur(90px)' }} />

      <div
        className="glass-hi rounded-3xl w-full max-w-md overflow-hidden animate-scale-up"
        style={{ border: '1px solid var(--glass-border-h)' }}
      >
        <div style={{ height: 3, background: 'var(--grad-brand)' }} />

        <div className="p-8">
          {/* Avatar upload */}
          <div className="flex justify-center mb-6">
            <label htmlFor="profileImg" className="cursor-pointer group">
              <div
                className="
                  relative w-20 h-20 rounded-full overflow-hidden
                  border-2 transition-all duration-300
                  group-hover:border-[var(--indigo)]
                "
                style={{
                  borderColor: 'var(--glass-border)',
                  background: 'var(--bg-raised)',
                }}
              >
                {data.image
                  ? <img src={data.image} alt="avatar" className="w-full h-full object-cover" />
                  : <BsPersonCircle
                      className="w-full h-full p-3"
                      style={{ color: 'var(--text-muted)' }}
                    />
                }
                <div className="
                  absolute inset-0 flex items-center justify-center
                  bg-black/50 opacity-0 group-hover:opacity-100
                  transition-opacity duration-200
                ">
                  <MdAddAPhoto className="text-xl text-white" />
                </div>
              </div>
              <input
                type="file" id="profileImg" accept="image/*"
                className="hidden" onChange={handleImage}
              />
            </label>
          </div>

          <h1 className="font-display text-2xl font-bold text-center mb-1"
              style={{ color: 'var(--text-primary)' }}>
            CREATE ACCOUNT
          </h1>
          <p className="text-center text-xs font-mono mb-7" style={{ color: 'var(--text-muted)' }}>
            Join the Home Electric family
          </p>

          <form onSubmit={submit}>
            {/* First & Last Name side-by-side */}
            <div className="grid grid-cols-2 gap-3 mb-3">
              {fields.slice(0, 2).map(({ name, label, type, Icon, placeholder }) => (
                <div key={name}>
                  <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                         style={{ color: 'var(--text-muted)' }}>
                    {label}
                  </label>
                  <div className="relative">
                    <Icon
                      className="absolute left-3 top-1/2 -translate-y-1/2 text-base pointer-events-none"
                      style={{ color: 'var(--text-muted)' }}
                    />
                    <input
                      type={type} name={name} placeholder={placeholder}
                      className="input-glass pl-9 pr-3 py-2.5 rounded-xl text-sm"
                      value={data[name]} onChange={handle}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Remaining fields */}
            <div className="flex flex-col gap-3 mb-5">
              {fields.slice(2).map(({ name, label, type, Icon, placeholder }) => (
                <div key={name}>
                  <label className="block text-xs font-mono mb-1.5 tracking-wider uppercase"
                         style={{ color: 'var(--text-muted)' }}>
                    {label}
                  </label>
                  <div className="relative">
                    <Icon
                      className="absolute left-3 top-1/2 -translate-y-1/2 text-lg pointer-events-none"
                      style={{ color: 'var(--text-muted)' }}
                    />
                    <input
                      type={type} name={name} placeholder={placeholder}
                      className="input-glass pl-10 pr-4 py-3 rounded-xl"
                      value={data[name]} onChange={handle}
                    />
                  </div>
                </div>
              ))}
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full py-3.5 rounded-xl flex items-center justify-center gap-2"
            >
              {loading ? (
                <span
                  className="w-4 h-4 rounded-full border-2 animate-spin"
                  style={{ borderColor: 'rgba(0,0,0,0.2)', borderTopColor: '#000' }}
                />
              ) : (
                <><BsLightningChargeFill /> Create Account</>
              )}
            </button>
          </form>

          <p className="text-center text-xs mt-5" style={{ color: 'var(--text-muted)' }}>
            Already have an account?{' '}
            <Link to="/login" className="font-semibold hover:underline"
                  style={{ color: 'var(--indigo-light)' }}>
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}